import { Navigate } from 'react-router-dom';
import React, { useEffect } from 'react';

interface Props {
  location: any;
  redirectPath: string;
  referrer: string;
}

export const PaymentRoute = (props: Props) => {
  return !props.location.pathname.includes(props.redirectPath) ? (
    <Navigate to={props.redirectPath} state={{ referrer: props.referrer, search: props.location.search }} />
  ) : (
    <></>
  );
};
